export default __webpack_public_path__ + "static/media/start-trial.45266fa9.png";